import services from '@/config/services'

export default class RepresentativeDocumentsService {
  constructor(http) {
    this.http = http
    this.baseUrl = services.ask_pratiche.url
    this.available = false
  }

  setAvailable(available) {
    this.available = available === true
  }

  async getClientNominations(clientId) {
    if (!this.available) return []
    const response = await this.http.get(`${this.baseUrl}/clienti/${clientId}/documenti-rappresentante`)
    return response.data.data || []
  }

  async getRepresentativeDocuments(representativeId) {
    if (!this.available) return []
    const response = await this.http.get(`${this.baseUrl}/rappresentanti/${representativeId}/documenti-rappresentante`)
    return response.data.data || []
  }

  openClientNomination(clientId, documentId) {
    if (!this.available) return Promise.reject(new Error('Documenti del rappresentante non disponibili.'))
    return this.openFile(`${this.baseUrl}/clienti/${clientId}/documenti-rappresentante/${documentId}/file`)
  }

  openRepresentativeDocument(representativeId, documentId) {
    if (!this.available) return Promise.reject(new Error('Documenti del rappresentante non disponibili.'))
    return this.openFile(`${this.baseUrl}/rappresentanti/${representativeId}/documenti-rappresentante/${documentId}/file`)
  }

  async openFile(url) {
    const tab = window.open('', '_blank')
    if (!tab) throw new Error('Il browser ha impedito l’apertura della nuova scheda.')
    try {
      const response = await this.http.get(url, { responseType: 'blob' })
      const blobUrl = URL.createObjectURL(response.data)
      tab.location.replace(blobUrl)
    } catch (error) {
      tab.close()
      throw error
    }
  }
}
